// Auto-generated file by CI/CD
export const APP_VERSION = '6.2.266';
